import { useRef } from 'react';

/**
 * Simplified hook that only provides scroll position maintenance
 * We don't need historical chat functionality since we only care about the current session
 */
const useHistoricChat = () => {
  const prevScrollHeightRef = useRef(0);

  return {
    prevScrollHeightRef
  };
};

export default useHistoricChat; 